import type { TenantSignupStep } from "./tenant-signup-shell"

export type TenantSignupFlowStep = "account" | "verification" | "shop-info"

interface TenantSignupFlowCopy {
  accountTitle: string
  verificationTitle: string
  shopInfoTitle: string
}

export const getTenantSignupFlow = (
  currentStep: TenantSignupFlowStep,
  copy: TenantSignupFlowCopy
): {
  title: string
  steps: TenantSignupStep[]
} => {
  const order: TenantSignupFlowStep[] = ["account", "verification", "shop-info"]
  const currentIndex = order.indexOf(currentStep)

  const stepLabels: Record<TenantSignupFlowStep, string> = {
    account: copy.accountTitle,
    verification: copy.verificationTitle,
    "shop-info": copy.shopInfoTitle,
  }

  return {
    title: stepLabels[currentStep],
    steps: order.map((step, index) => ({
      id: step,
      label: stepLabels[step],
      number: index + 1,
      status: index < currentIndex ? "complete" : index === currentIndex ? "current" : "upcoming",
    })),
  }
}
